"use client";

import React from "react";
import s from "../styles";
import { dayjs } from "@lib/client";

export default function EstimateArea({ data }) {
  const formatDateHour = (dateString) => {
    if (!dateString) return "";
    const d = dayjs(dateString);
    if (!d.isValid()) return "";
    return d.format("YYYY年M月D日 HH時");
  };

  const formatDateHM = (dateString) => {
    if (!dateString) return "";
    const d = dayjs(dateString);
    if (!d.isValid()) return "";
    return d.format("YYYY年M月D日 HH:mm");
  };

  const kj = data?.kaitoJyokyo || {};
  const hasOrderRec = !!kj?.OrderRec_Date;
  const hasHaiso = !!kj?.Haiso_Date;

  return (
    <s.DetailTable>
      <s.DetailCaption>見積回答期限</s.DetailCaption>
      <tbody>
        <tr>
          <s.DetailTh style={{ textAlign: "right" }}>見積回答期限</s.DetailTh>
          <s.DetailTd>{formatDateHour(data?.request?.Request_Limit)}</s.DetailTd>

          {hasOrderRec ? (
            <>
              <s.DetailTh>
                最新注文確定
                <br />
                日時
              </s.DetailTh>
              <s.DetailTd>{formatDateHM(kj?.OrderRec_Date)}</s.DetailTd>
            </>
          ) : null}

          {hasHaiso ? (
            <>
              <s.DetailTh>
                最新発送登録
                <br />
                日時
              </s.DetailTh>
              <s.DetailTd>{formatDateHM(kj?.Haiso_Date)}</s.DetailTd>
            </>
          ) : null}
        </tr>
      </tbody>
    </s.DetailTable>
  );
}
